import { useQuery } from "@tanstack/react-query"

import { GetEcobalyseProductTypesResponseDto } from "@tfg/types/schemas/modules/lifeCycleAnalysis/dtos/get-ecobalyse-product-types.response.dto"

import { httpClient } from "~/backend/axios"

export const useGetEcobalyseProductTypesQuery = () =>
  useQuery({
    queryKey: ["ecobalyse", "productTypes"],

    queryFn: async () => {
      const res = await httpClient.get<GetEcobalyseProductTypesResponseDto>(
        "/lca/get-ecobalyse-product-types"
      )

      return res.data
    },
  })
